module.exports = __webpack_public_path__ + "img/pineapple.e373a178.svg";